import React from 'react';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';

import buttonColor from './button-color';
import { ArrowRightIcon, CloseIcon } from './icons';
import {
  AddressStyle,
  BottomServiceWrapper,
  ButtonContainer,
  CartOverlayButton,
  Container,
  Details,
  Heading,
  IconContainer,
  LocationOverlayButton,
  LocationStyle,
  Underline,
} from './styled';
import theme from './theme';
import { BottomServiceVariants, IBottomServiceModeViewProps } from './types';

export const BottomServiceModeView = React.forwardRef<HTMLDivElement, IBottomServiceModeViewProps>(
  (
    {
      isLoading = false,
      variant = BottomServiceVariants.DEFAULT,
      heading,
      details,
      icon,
      buttonContentText,
      buttonContentIcon,
      onBottomServiceClick = () => {},
      onButtonClick = () => {},
      buttonDisabled = false,
      className = '',
    },
    ref
  ) => {
    if (isLoading) {
      return (
        <Container variant={variant} className={className} ref={ref}>
          <LoadingAnimation fillColor={Styles.color.white} />
        </Container>
      );
    }

    let buttonVariant: ActionButtonVariants;
    switch (variant) {
      case BottomServiceVariants.IN_PROGRESS:
        buttonVariant = theme.inProgressVariant;
        break;
      case BottomServiceVariants.NO_STORE:
        buttonVariant = ActionButtonVariants.INVERSE;
        break;
      case BottomServiceVariants.DEFAULT:
      default:
        buttonVariant = ActionButtonVariants.INVERSE;
    }
    const isClearAddressDisplayIcon = variant === BottomServiceVariants.DEFAULT;
    const isStatusUpdated = variant !== BottomServiceVariants.IN_PROGRESS;

    const color = buttonColor(variant);
    return (
      <Container variant={variant} className={className} ref={ref} data-testid="bottom-service">
        <BottomServiceWrapper>
          <LocationOverlayButton
            onClick={onBottomServiceClick}
            data-testid="bottom-service-location"
          ></LocationOverlayButton>
          <CartOverlayButton
            onClick={onButtonClick}
            disabled={buttonDisabled}
            data-testid="bottom-service-cart"
          ></CartOverlayButton>
          <IconContainer>{icon}</IconContainer>
          <Heading variant={variant}>{heading}</Heading>
          <Details variant={variant}>
            <LocationStyle>
              <AddressStyle>{details}</AddressStyle>
              {isClearAddressDisplayIcon ? <CloseIcon /> : isStatusUpdated && <ArrowRightIcon />}
            </LocationStyle>
            {isStatusUpdated && <Underline />}
          </Details>
          {buttonContentText && (
            <ButtonContainer>
              <ActionButton
                variant={buttonVariant}
                color={color}
                size={ActionButtonSizes.SMALL}
                data-testid="bottom-service-button"
                disabled={buttonDisabled}
                startIcon={buttonContentIcon}
              >
                {buttonContentText}
              </ActionButton>
            </ButtonContainer>
          )}
        </BottomServiceWrapper>
      </Container>
    );
  }
);
